import { render, staticRenderFns } from "./customRightClick.vue?vue&type=template&id=178b887c&scoped=true"
import script from "./customRightClick.vue?vue&type=script&lang=js"
export * from "./customRightClick.vue?vue&type=script&lang=js"
import style0 from "./customRightClick.vue?vue&type=style&index=0&id=178b887c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b887c",
  null
  
)

export default component.exports